module.exports = __webpack_public_path__ + "media/images/dolby_atmos_vision_enbl-13f49a8cd9a3e4b34242dfe2fd0d5efc.png";